<template>
    <app-layout title="Beheer">
        <template #header>
            <page-title title="Type opdrachten" />
        </template>

        <template #pageContent>
            <div class="flex justify-between w-1/2">
                <TableSearch tableId="configuration-assignment-types" :values="assignmentTypes" class="w-1/2" placeholder="Zoeken"/>

                <Modal buttonText="Toevoegen" buttonClass="add" ref="modal">
                    <h2>Type opdracht {{ modalTitleAction }}</h2>
                    <Form @submitted="handleSubmit" class="w-full">
                        <Input type="hidden" name="id" v-model="form.id" />
                        <Input type="text" label="Opdracht" name="name" :required="true" v-model="form.name" :error="form.errors.name" />
                        <Select
                            label="Categorie"
                            name="assignment_type_category_id"
                            :options="assignmentTypeCategories"
                            v-model="form.assignment_type_category_id"
                            :error="form.errors.assignment_type_category_id"
                        />
                        <Input type="number" label="Urgent" name="urgent" v-model="form.urgent" :error="form.errors.urgent"/>
                        <Input type="number" label="Niet urgent" name="non_urgent" v-model="form.non_urgent" :error="form.errors.non_urgent" />

                        <div class="inline-block self-end mt-4">
                            <Button text="Annuleren" buttonClass="secondary" data-modal="close" @click="form.reset()" />
                            <Button
                                :text="modalTitleAction"
                                buttonType="submit"
                                buttonClass="save"
                                class="capitalize"
                                :loading="form.processing"
                            />
                        </div>
                    </Form>
                </Modal>
            </div>

            <Table id="configuration-assignment-types" :values="assignmentTypes" class="w-1/2">
                <thead>
                <tr>
                    <Th id="name">Opdracht</th>
                    <Th id="assignment_type_category.name">Categorie</th>
                    <Th id="urgent">Urgent</th>
                    <Th id="non_urgent">Niet urgent</th>
                    <Th :sort="false" class="w-[75px]"></Th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(assignmentType, key) in state.sortedValues['configuration-assignment-types']" :key="key">
                    <Td>{{ assignmentType.name }}</Td>
                    <Td>
                        <template v-if="assignmentType.assignment_type_category">
                            {{ assignmentType.assignment_type_category.name }}
                        </template>
                    </Td>
                    <Td>{{ assignmentType.urgent }}</Td>
                    <Td>{{ assignmentType.non_urgent }}</Td>
                    <Td>
                        <Button buttonClass="edit" size="small" title="Bewerken" @click="updateAssignmentType(assignmentType)" />
                        <Button buttonClass="delete" size="small" title="Verwijderen" @click="deleteAssignmentType(assignmentType)" />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import { useForm } from "@inertiajs/inertia-vue3"
import { onMounted, ref, watch} from "vue"
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Form,
        Input,
        Select,
    },
    props: [
        'assignmentTypes',
        'assignmentTypeCategories',
    ],
    setup (props)
    {
        let modalTitleAction = ref('toevoegen') //of bewerken
        const modal = ref(null)

        const form = useForm({
            id: null,
            name: null,
            assignment_type_category_id: null,
            urgent: null,
            non_urgent: null,
        })

        function updateAssignmentType(assignmentType)
        {
            form.id = assignmentType.id
            form.name = assignmentType.name
            form.assignment_type_category_id = assignmentType.assignment_type_category_id
            form.urgent = assignmentType.urgent
            form.non_urgent = assignmentType.non_urgent

            modalTitleAction.value = 'bewerken'
            modal.value.show = true
        }

        function deleteAssignmentType(assignmentType)
        {
            if (!confirm('Bent u zeker dat u dit type opdracht wil verwijderen?'))
                return

            Inertia.delete('/configuration/assignment_types/' + assignmentType.id)
        }

        function handleSubmit()
        {
            if (modalTitleAction.value == 'toevoegen')
            {
                //Store
                form.post('/configuration/assignment_types', {
                    onSuccess: () => {
                        modal.value.show = false
                        form.clearErrors()
                        form.reset()
                    },
                })
            }
            else
            {
                form.urgent = (form.urgent != '') ? form.urgent : null
                form.non_urgent = (form.urgent != '') ? form.non_urgent : null

                //Update
                form.put('/configuration/assignment_types/' + form.id, {
                    onSuccess: () => {
                        modal.value.show = false
                        form.clearErrors()
                        form.reset()
                    },
                })
            }
        }

        onMounted(() => {
            //Check if modal gets closed
            watch(() => modal.value.show, (modalShow, prevModalShow) => {
                if (!modalShow) {
                    //Reset to default values
                    setTimeout(function() {
                            modalTitleAction.value = 'toevoegen'
                            form.clearErrors()
                            form.reset()
                        },
                        500
                    );
                }
            })
        })

        return {
            state: store.state,
            ...store,
            form,
            handleSubmit,
            modal,
            modalTitleAction,
            updateAssignmentType,
            deleteAssignmentType,
        }
    },
}

</script>
